<template>
	<div
		class="g-block-title-badge g-block-title-padding"
		:class="{
			'g-block-title-badge--edit': editable,
			'is-active': editable && active,
			'g-block-title-badge--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-badge__inner" :style="{ background: themeColor }">
			<RichTextEditable
				v-if="editable"
				class="g-block-title-badge__text"
				fit-content
				:model-value="data.content"
				placeholder="请输入标题"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-title-badge__text"
				v-html="data.content || ''"
			></div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { singleTitleMixin } from '../shared/singleTitleMixin.js';

	export default {
		name: 'GBlockTitleBadge',
		components: { RichTextEditable },
		mixins: [singleTitleMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	.g-block-title-badge {
		.title-block-edit-shell();
		text-align: center;
	}

	.g-block-title-badge__inner {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		max-width: 100%;
		padding: 8px 20px;
		border-radius: 20px 6px 20px 6px;
	}

	.g-block-title-badge__text {
		font-size: 18px;
		font-weight: 700;
		line-height: 1.2;
		color: #fff;
		:deep(.g-rich-text-editable__content) {
			min-height: unset;
			padding: 0;
			font-weight: 700;
			color: inherit;
		}
	}

	.g-block-title-badge--h5 {
		.g-block-title-badge__inner { padding: 0.16rem 0.4rem; border-radius: 0.4rem 0.12rem 0.4rem 0.12rem; }
		.g-block-title-badge__text { font-size: 0.36rem; }
	}
</style>
